<div class="mb-3">
  <nh-alert type="success" [isOpen]="updateSuccess">
    <div class="col message">
      <span>{{ "AUTO_RENEWAL_SUCCESS_MESSAGE" | globalTranslate }}</span>
    </div>
  </nh-alert>
  <div class="bg-custom">
    <h1 class="section-header margin-l-10">
      {{ "AUTO_RENEWAL_STATIC_HEADER1" | globalTranslate }}
    </h1>
    <hr />
    <form [formGroup]="autoRenewalForm">
      @if (caseList.length > 1) {
      <div class="row">
        <div class="col-sm-5">
          <label class="label-section">{{
            "CASE_NUMBER" | globalTranslate
          }}</label>
          <select
            nh
            name="caseNumber"
            style="width: 340px; height: 48px"
            [attr.aria-label]="'CASE_NUMBER' | globalTranslate"
            [items]="caseNumbers"
            (change)="onCaseSelect()"
            formControlName="caseNumber"
          ></select>
        </div>
        <div class="col-sm-4">
          <button
            id="select"
            class="btn btn-secondary btn-search"
            [disabled]="!enableSelect"
            (click)="onSelectedCase()"
          >
            {{ "SELECT_APPEAL" | globalTranslate }}
          </button>
        </div>
      </div>
      } @if (caseList.length === 1) {
      <div>
        <p class="static-text margin-l-10">
          <b>{{ "CASE_NUMBER" | globalTranslate }}</b
          ><span style="margin-left: 5px">{{ caseList[0].caseNum }}</span>
        </p>
      </div>
      } @if (showRenewSW === 'Y' && caseSelected) {
      <div class="container">
        <h2 class="section-header">
          {{ "AUTO_RENEWAL_STATIC_HEADER2" | globalTranslate }}
        </h2>
        <hr />
        <p>{{ "AUTO_RENEWAL_STATIC_HEADER3" | globalTranslate }}</p>
        <div>
          <p class="static-text">
            <b
              ><span class="requiredfd" aria-hidden="true">*</span
              ><span class="visually-hidden">{{
                "required" | globalTranslate
              }}</span
              >{{ "BEFORE_SUBMIT_STATIC_TEXT24" | globalTranslate }}</b
            >
          </p>
          <div class="d-flex gap-4">
            <label class="radio-inline checkbox" for="renewCoverageYesCheck">
              <input
                #isrenewcheckYes
                class="chk-input chk-gap"
                id="renewCoverageYesCheck"
                type="checkbox"
                [attr.aria-required]="true"
                (change)="isRenewChecked($event, isrenewcheckNo)"
                (keydown.enter)="isRenewChecked($event, isrenewcheckNo)"
                (keydown.space)="isRenewChecked($event, isrenewcheckNo)"
                name="renewCoverageYesCheck"
                formControlName="renewCoverageYesCheck"
                value="Yes"
              />
              <span class="chk-lbl">{{ "Yes" | globalTranslate }}</span>
            </label>
            <label class="radio-inline checkbox" for="renewCoverageNoCheck">
              <input
                #isrenewcheckNo
                class="chk-input chk-gap"
                id="renewCoverageNoCheck"
                type="checkbox"
                [attr.aria-required]="true"
                (change)="isRenewChecked($event, isrenewcheckYes)"
                (keydown.enter)="isRenewChecked($event, isrenewcheckYes)"
                (keydown.space)="isRenewChecked($event, isrenewcheckYes)"
                name="renewCoverageNoCheck"
                formControlName="renewCoverageNoCheck"
                value="No"
              />
              <span class="chk-lbl">{{ "No" | globalTranslate }}</span>
            </label>
          </div>
        </div>
        <br />
        @if (enableRenewEligibility) {
        <nh-field
          [isRow]="true"
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'AUTO_RENEWAL_STATIC_TEXT1' | globalTranslate }}"
        >
          <select
            nh
            name="yearsRenewedCD"
            [attr.aria-label]="'AUTO_RENEWAL_STATIC_TEXT1' | globalTranslate"
            [items]="items"
            (change)="renewEligbilitySelect()"
            formControlName="yearsRenewedCD"
            [attr.aria-required]="true"
          ></select>
        </nh-field>
        }
      </div>
      } @if (showAvsSW === 'Y' && caseSelected) {
      <div class="container">
        <h2 class="section-header">
          {{ "AUTO_RENEWAL_STATIC_HEADER4" | globalTranslate }}
        </h2>
        <hr />
        <p>{{ "AUTO_RENEWAL_STATIC_TXT4" | globalTranslate }}</p>
        <br />
        @if (caseSelected) {
        <div>
          <p class="static-text">
            <b
              ><span class="requiredfd" aria-hidden="true">*</span
              ><span class="visually-hidden">{{
                "required" | globalTranslate
              }}</span
              >{{ "AUTO_RENEWAL_STATIC_TXT5" | globalTranslate }}</b
            >
          </p>
          <div class="d-flex gap-4">
            <label class="radio-inline checkbox" for="avsYesCheck">
              <input
                #isAvsRenewcheckYes
                class="chk-input chk-gap"
                id="avsYesCheck"
                type="checkbox"
                [attr.aria-required]="true"
                (change)="isAvsRenewChecked($event, isAvsRenewcheckNo)"
                (keydown.enter)="isAvsRenewChecked($event, isAvsRenewcheckNo)"
                (keydown.space)="isAvsRenewChecked($event, isAvsRenewcheckNo)"
                name="avsYesCheck"
                formControlName="avsYesCheck"
                value="Yes"
              />
              <span class="chk-lbl">{{ "Yes" | globalTranslate }}</span>
            </label>
            <label class="radio-inline checkbox" for="avsNoCheck">
              <input
                #isAvsRenewcheckNo
                class="chk-input chk-gap"
                id="avsNoCheck"
                type="checkbox"
                [attr.aria-required]="true"
                (change)="isAvsRenewChecked($event, isAvsRenewcheckYes)"
                (keydown.enter)="isAvsRenewChecked($event, isAvsRenewcheckYes)"
                (keydown.space)="isAvsRenewChecked($event, isAvsRenewcheckYes)"
                name="avsNoCheck"
                formControlName="avsNoCheck"
                value="No"
              />
              <span class="chk-lbl">{{ "No" | globalTranslate }}</span>
            </label>
          </div>
        </div>
        }
        <br />
        <div>
          <p [innerHTML]="'AUTO_RENEWAL_STATIC_TXT6' | globalTranslate"></p>
        </div>
      </div>
      }
    </form>
    @if (caseSelected) {
    <div class="row mt-3 text-center py-4">
      <div class="col-auto">
        <button
          id="continue"
          class="btn btn-block d-grid btn-secondary btn-width"
          [disabled]="!(enableUpdate && enableAVSUpdate)"
          (click)="updateAutoRenewal()"
        >
          {{ "COMMUNICATION_UPDATE" | globalTranslate }}
        </button>
      </div>
      <div class="col-auto">
        <button
          id="btn-cancel"
          class="btn btn-block d-grid btn-outline-secondary"
          [disabled]="false"
          (click)="exitAutoRenewal()"
        >
          {{ "EXIT" | globalTranslate }}
        </button>
      </div>
    </div>
    }
  </div>
</div>